import { noop } from '@kofno/piper';
import { observer } from 'mobx-react';
import { T } from '../../../../Translations';
import { State } from './UseParticipantDynamicTypeaheadSelect/Types';

interface Props {
  inputValue: string;
  state: State;
}

function NoOptionsMessage({ inputValue, state }: Props) {
  switch (state.kind) {
    case 'filtered':
      return (
        <div className="text-left text-sm px-2 cursor-pointer py-2 flex items-center">
          <T kind="No matches for {{name}}" name={inputValue} />
        </div>
      );
    case 'error':
    case 'filtering':
    case 'loading':
    case 'option-selected':
    case 'ready':
      return (
        <div
          onClick={noop}
          className="text-left text-sm px-2 cursor-pointer py-2 flex items-center"
        >
          <T kind="Type at least 3 character to load options" />
        </div>
      );
  }
}
export default observer(NoOptionsMessage);
